import React from "react";
import { Check, CheckCircle, CheckSquare, Square } from "lucide-react";
import clsx from "clsx";

export interface CheckIconProps {
  size?: number;
  className?: string;
  variant?: "default" | "success" | "checkbox" | "circle" | "square" | "unchecked";
}

export const CheckIcon = React.forwardRef<SVGSVGElement, CheckIconProps>(
  ({ size = 16, className, variant = "default", ...props }, ref) => {
    const baseClasses = "transition-colors";

    const variantClasses = {
      default: "text-card-foreground",
      success: "text-green-600",
      checkbox: "text-current",
      circle: "text-green-600",
      square: "text-card-foreground",
      unchecked: "text-gray-400",
    };

    const getIcon = () => {
      switch (variant) {
        case "circle":
          return (
            <CheckCircle
              size={size}
              className={clsx(baseClasses, variantClasses[variant], className)}
              {...props}
            />
          );
        case "square":
          return (
            <CheckSquare
              size={size}
              className={clsx(baseClasses, variantClasses[variant], className)}
              {...props}
            />
          );
        case "unchecked":
          return (
            <Square
              size={size}
              className={clsx(baseClasses, variantClasses[variant], className)}
              {...props}
            />
          );
        default:
          return (
            <Check
              size={size}
              className={clsx(baseClasses, variantClasses[variant], className)}
              {...props}
            />
          );
      }
    };

    return React.cloneElement(getIcon(), { ref });
  }
);

CheckIcon.displayName = "CheckIcon";
